import React from 'react'
import { NavLink } from 'react-router-dom'
import { IoIosExit } from 'react-icons/io'

import { CountryDetails } from '../../types'
import './style.scss'

const ViewCountry = ({
  flag,
  name,
  capital,
  area,
  languages,
  population,
  region,
  currencies,
  maps,
}: CountryDetails) => {
  const formattedLanguages = languages && Object.values(languages)
  const formattedCurrencies = currencies && Object.values(currencies)

  return (
    <tr className="country-details animate-appear">
      <td className="country-details__exit">
        <NavLink to="/">
          <IoIosExit height={2} width={2} aria-hidden="true" />
        </NavLink>
      </td>
      <td className="country-details__flag-container">
        <img src={flag} alt={name} />
      </td>
      <tr className="country-details__wrapper">
        <td>{name}</td>
        <td>Capital: {capital ? capital : 'N/A'}</td>
        <td>Area: {area ? area : 'N/A'}</td>
        <td className="country-details__languages">
          Languages:
          {formattedLanguages !== undefined ? (
            formattedLanguages.map((language: any, i) => (
              <li key={language}>
                <span>{language}</span>
                <>{i === formattedLanguages.length - 1 ? '' : ','}</>&nbsp;
              </li>
            ))
          ) : (
            <>N/A</>
          )}
        </td>
        <td>Population: {population}</td>
        <td>Region: {region}</td>
        <td className="country-details__currencies">
          Currencies:
          {formattedCurrencies !== undefined ? (
            formattedCurrencies.map((currency: any, i: any) => {
              return (
                <li key={i}>
                  <span>{currency?.name}</span>
                </li>
              )
            })
          ) : (
            <>N/A</>
          )}
        </td>
        <td>
          <a href={`${maps.googleMaps}`} target="blank">
            Link to Google Maps
          </a>
        </td>
      </tr>
    </tr>
  )
}

export default ViewCountry
